import { connect } from "react-redux";
import {
  fetchCountries,
  setCountry,
} from "../../actions/PremierSelectorOptions";
import { toggleSelector } from "../../actions/Modal";
import PremierSelectorOptions from "../../components/PremierSelectorOptions/index.jsx";

const mapStateToProps = (state) => ({
  countriesData: state.PremierSelectorOptions.countriesData,
  selectedCountry: state.PremierSelectorOptions.selectedCountry,
  isVisible: state.Modal.countrySelectorisVisible,
  premierCountrySelector: state.PremierPageFrame.content.premierCountrySelector,
  assetsUrl: state.Environment.assetsUrl,
  returnFocus: state.Modal.returnFocus,
});

const mapDispatchToProps = (dispatch) => ({
  closeCountrySelector: (returnFocus) => {
    dispatch(toggleSelector(false, returnFocus));
  },
  fetchCountries: (country, currency, storeId, language) => {
    dispatch(fetchCountries(country, currency, storeId, language));
  },
  setCountry: (countryCode, countriesData, language, currency, storeId) => {
    dispatch(
      setCountry(countryCode, countriesData, language, currency, storeId)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremierSelectorOptions);
